document.addEventListener("DOMContentLoaded", () => {
  const targetNode = document.getElementById("CollectionProductContainer");

  if (!targetNode) return;

  const removeCollapsedClass = () => {
    const items = document.querySelectorAll(
      "#gf-tree .gf-filter-contents > div"
    );
    const product_items =  document.querySelectorAll(
      "#gf-products > div"
    );
    items.forEach((item) => {
      item.classList.remove("is-collapsed");
    });

    product_items.forEach((item) => {
      item.classList.remove("spf-col-xl-4");
      item.classList.add("spf-col-xl-3");
      console.log("work");
    });


  };

  // Initial run
  removeCollapsedClass();

  // Watch for dynamic changes
  const observer = new MutationObserver(() => {
    removeCollapsedClass();
  });

  observer.observe(targetNode, {
    childList: true,
    subtree: true,
  });

});
$('body').on('click', '#mobile_menu a.site-nav__link--main', function(e) {
    const href = $(this).attr('href');
    if (href && href !== '#') {
        window.location.href = href;
    }
});
$('body').on('click', '.mm-listview a', function(e) {
    const href = $(this).attr('href');
    console.log(href);
    /*if (href && href !== '#') {
        window.location.href = href;
    }*/
});

jQuery(function($){
    const observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
            ) {
                const $el = $(mutation.target);

                if ($el.is("a") && $el.hasClass("active")) {
                      $el.closest(".dropdown").removeClass("show");
                      $el.closest(".dropdown-menu").removeClass("show");

                      
                }
            }
        });
    });

    $(".dropdown-menu a").each(function () {
        observer.observe(this, {
            attributes: true,
            attributeFilter: ["class"]
        });
    });
});